import React from 'react';
import { 
  Plus, 
  Inbox, 
  Star, 
  Clock, 
  Send, 
  FileText, 
  ChevronDown,
  Tag,
  AlertCircle,
  User,
  Video,
  Phone
} from 'lucide-react';

const SidebarOption = ({ Icon, title, count, selected, onClick }) => {
  return (
    <button 
      onClick={onClick}
      className={`gmail-sidebar-option ${selected ? 'gmail-sidebar-option--active' : ''}`}
      data-testid={`sidebar-option-${title.toLowerCase()}`}
    >
      <Icon size={20} />
      <span className="gmail-sidebar-option-title">{title}</span>
      {count !== undefined && (
        <span className="gmail-sidebar-option-count">{count}</span>
      )}
    </button>
  );
};

const GmailSidebar = ({ 
  onCompose, 
  activeSection, 
  onSectionChange,
  inboxCount,
  starredCount,
  sentCount
}) => {
  return (
    <div className="gmail-sidebar" data-testid="gmail-sidebar">
      <button 
        className="gmail-compose-btn" 
        onClick={onCompose}
        data-testid="gmail-compose-btn"
      >
        <Plus size={20} />
        <span>Compose</span>
      </button>

      <div className="gmail-sidebar-options">
        <SidebarOption
          Icon={Inbox}
          title="Inbox"
          count={inboxCount}
          selected={activeSection === 'inbox'}
          onClick={() => onSectionChange('inbox')}
        />
        <SidebarOption
          Icon={Star}
          title="Starred"
          count={starredCount}
          selected={activeSection === 'starred'}
          onClick={() => onSectionChange('starred')}
        />
        <SidebarOption
          Icon={Clock}
          title="Snoozed"
          selected={activeSection === 'snoozed'}
          onClick={() => onSectionChange('snoozed')}
        />
        <SidebarOption
          Icon={AlertCircle}
          title="Important"
          selected={activeSection === 'important'}
          onClick={() => onSectionChange('important')}
        />
        <SidebarOption
          Icon={Send}
          title="Sent"
          count={sentCount}
          selected={activeSection === 'sent'}
          onClick={() => onSectionChange('sent')}
        />
        <SidebarOption
          Icon={FileText}
          title="Drafts"
          selected={activeSection === 'drafts'}
          onClick={() => onSectionChange('drafts')}
        />
        <SidebarOption
          Icon={ChevronDown}
          title="More"
          onClick={() => {}}
        />
      </div>

      <div className="gmail-sidebar-footer">
        <div className="gmail-sidebar-footer-icons">
          <button className="gmail-icon-btn">
            <User size={20} />
          </button>
          <button className="gmail-icon-btn">
            <Video size={20} />
          </button>
          <button className="gmail-icon-btn">
            <Phone size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GmailSidebar;
